export default __webpack_public_path__ + "static/media/done.e2fe0a47.svg";